/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

import twMerge from 'utilities/src/twMerge';

/**
 * Widget Card Props
 */

export type WidgetCardProps = {
  children: React.ReactNode;
  className?: string;
  floating?: boolean;
};

/**
 * Widget Card Component
 */

export default function WidgetCard({ children, className, floating }: WidgetCardProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={twMerge(
        'shadow-lv5 bg-site-neutrals-0 flex h-fit flex-col rounded-lg border md:max-w-[17.625rem]',
        className,
        floating && !isOpen && 'max-h-[3.75rem] w-64 max-w-64 overflow-clip',
        floating && isOpen && 'is-open group max-h-fit w-[19rem] max-w-[19rem] overflow-visible',
      )}
      onClick={() => setIsOpen(!isOpen)}
    >
      {children}
    </div>
  );
}
